import { View, Text } from "react-native";
import React from "react";
import getToken from "../../api/token";

export default function ChartShow({ type, childId }) {
  return (
    <div id="baseDiv">
      <iframe
        frameborder="0"
        style={{ overflow: "hidden", height: "900px", width: "100%" }}
        width="100%"
        src={`https://chart.asqtest.ir/?childId=${childId}&token=${getToken()}&type=${type}&isDoctor=1`}
      ></iframe>
    </div>
  );
}
